export default {
  navHome: "Ana Sayfa",
  navProducts: "Ürünler",
  navCases: "Uygulama Örnekleri",
  navAbout: "Hakkımızda",
  deliverTo: "Teslimat:",
  langCurrencyLabel: "Türkçe",
  localeLangTitle: "Dil ayarla",
  localeLangDesc:
    "Tercih ettiğiniz dili seçin. Bu ayarı istediğiniz zaman güncelleyebilirsiniz.",
  language: "Dil",
  save: "Kaydet",
  coreProducts: "Gerçek dünyada yaratıcılığı güçlendiriyoruz.",
  coreProductsDesc:
    "Fikirden işe �?YONGYUAN UV yazıcılar, kristal etiket yazıcılar, yüksek hızlı silindirik yazıcılar, DTF ve DTG yazıcılar sunarak yaratıcılığı ürünlere, markalara ve fırsatlara dönüştürür.",
  scenariosTitle: "Her senaryo için çözüm",
  scenariosDesc:
    "Marka oluşturuyor, yan iş geliştiriyor veya yaratıcı tutkularınızı takip ediyor olun, YONGYUAN ihtiyaçlarınıza uygun bir çözüm sunar.",
  scenarioStudio: "Stüdyo",
  scenarioStudioDesc:
    "Yüksek değerli özelleştirme, küçük seri prototipleme ve marka oluşturma",
  scenarioRetail: "Marka perakende",
  scenarioRetailDesc:
    "Müşteri kalış süresini ve mağaza gelirini artırın",
  scenarioMarket: "Açık pazar",
  scenarioMarketDesc:
    "Yerinde özelleştirme, bitmiş ürün satışı ve ek gelir",
  scenarioEnterprise: "Kurumsal özelleştirme",
  scenarioEnterpriseDesc:
    "Toplu özelleştirme, markalı ürünler ve kurumsal hediyeler",
  scenarioEcommerce: "Canlı yayın satışı",
  scenarioEcommerceDesc:
    "Hit ürün numuneleri, esnek tedarik ve hızlı ürün lansmanları",
  scenarioStore: "E-ticaret mağazası",
  scenarioStoreDesc:
    "Mağaza özelleştirme, hit ürünler ve farklılaştırılmış operasyonlar",
  scenarioFactory: "Fabrika üretimi",
  scenarioFactoryDesc:
    "Toplu üretim, istikrarlı çıktı ve maliyet etkin operasyonlar",
  scenarioAdvertising: "Reklam üretimi",
  scenarioAdvertisingDesc:
    "Tabelalar, sergi malzemeleri ve etkinlik materyalleri",
  industries: "Sektör uygulamaları",
  industriesDesc:
    "Farklı sektörlerde renkli baskı için dijital mürekkep püskürtmeli baskı çözümleri.",
  applicationsTitle:
    "Günlük ve ticari ihtiyaçlar için çok yönlü malzeme ve renk uygulamaları.",
  applicationsDesc:
    "YONGYUAN UV baskı ekipmanları geniş malzeme ve proses senaryoları için tasarlanmış olup hem kişiselleştirilmiş özelleştirme hem de büyük ölçekli üretimi destekler.",
  casesHeroDesc:
    "1200'den fazla sektör uygulaması ve on binlerce baskı yapılabilir malzeme — farklı işletmeler için dijital baskı çözümleri.",
  casesBreadcrumbHome: "Ana Sayfa",
  casesBreadcrumbCenter: "Uygulama Örnekleri",
  casesEmpty: "Bu kategoride henüz uygulama örneği yok.",
  customerStoriesTitle: "Dünya Çapında Müşteriler Tarafından Güveniliyor",
  customerStoriesSubtitle:
    "172 ülkede gerçek kurulumlar, gerçek müşteriler, gerçek baskı işletmeleri.",
  customerStoriesStat1Value: "53.000+",
  customerStoriesStat1Label: "Teslim edilen yazıcı",
  customerStoriesStat2Value: "172+",
  customerStoriesStat2Label: "Hizmet verilen ülke",
  customerStoriesStat3Value: "23+",
  customerStoriesStat3Label: "Yıllık deneyim",
  customerStoriesStat4Value: "24/7",
  customerStoriesStat4Label: "Teknik destek",
  customerStoriesPlaceholder: "Müşteri fotoğrafı ekle",
  customerStoriesPhotoAlt: "YONGYUAN müşterisi ve yazıcı",
  servicePartnerTitle:
    "YONGYUAN servis ekibiyle tanışın, yaratıcı ortağınız",
  servicePartnerDesc:
    "Ekipman performansınızı ve iş büyümenizi korumak için küresel servis ağı ve profesyonel destek sistemi.",
  serviceSupportTitle: "Standart destek",
  serviceSupportDesc:
    "Kurulum rehberliği, temel eğitim ve günlük kullanım desteği ile güvenilir çalışma.",
  servicePresaleTitle: "Satış öncesi demo ve danışmanlık",
  servicePresaleDesc:
    "Uygulama senaryolarınıza ve kapasite gereksinimlerinize uygun çözüm demoları ve model önerileri.",
  serviceLifetimeTitle: "Ömür boyu teknik destek",
  serviceLifetimeDesc:
    "Uzun vadeli iş gelişiminizi destekleyen sürekli teknik yanıt ve süreç desteği.",
  serviceCareTitle: "YONGYUAN Care'e yükseltin",
  serviceCareDamageTitle: "Kazara hasar koruması",
  serviceCareDamageDesc:
    "Beklenmedik olaylardan kaynaklanan kayıpları azaltmak için daha kapsamlı koruma planı.",
  serviceCareExchangeTitle: "Hızlı değişim hizmeti",
  serviceCareExchangeDesc:
    "Uygun koşullarda öncelikli hızlı değişim düzenlemeleri ile sermaye geri kazanımını hızlandırın.",
  viewProduct: "Ürünleri görüntüle",
  learnMore: "Daha fazla bilgi",
  catUv: "UV düz yatak yazıcı",
  catCylinder: "Silindirik yazıcı",
  catCrystal: "Kristal etiket yazıcı",
  catDtf: "DTF yazıcı",
  catDtg: "DTG yazıcı",
  companyName: "Shenzhen Yongyuan Technology Co., Ltd.",
  phone: "Telefon: 17748697567 Müdür Tang",
  email: "E-posta: sales@yongyuanprinter.com",
  copyright:
    "Copyright © 2012-2026 Shenzhen Yongyuan Technology Co., Ltd. Tüm hakları saklıdır",
  productsHeroTitle: "Ürünler",
  productsHeroDesc:
    "Çeşitli kapasite ve uygulama ihtiyaçları için UV düz yatak, silindirik, kristal etiket, DTF ve DTG ekipmanlarının tam serisi.",
  productsBreadcrumbHome: "Ana Sayfa",
  productsBreadcrumbCenter: "Ürünler",
  productsEmpty: "Bu kategorideki ürünler yakında gelecek.",
  productsQuoteTitle: "Çözüm ve teklif isteyin",
  productsQuoteDesc:
    "Uygulama senaryolarınızı ve kapasite gereksinimlerinizi paylaşın, size uygun ekipman çözümünü önerelim.",
  productsContact: "Bize ulaşın",
  aboutHeroTitle: "Yongyuan Hakkında",
  aboutHeroDesc:
    "UV baskı ekipmanı Ar-Ge ve üretimine 23 yıl odaklanma",
  productA23Subtitle: "Masaüstü 6 renkli akıllı UV yazıcı",
  productA23Feature1: "A4 baskı formatı",
  productA23Feature2: "Akıllı mürekkep besleme sistemi",
  productA23Feature3: "Kızılötesi otomatik yükseklik algılama",
  productA35Subtitle: "Masaüstü 6 renkli akıllı UV yazıcı",
  productA35Feature1: "A3+ baskı formatı",
  productA35Feature2: "Akıllı mürekkep besleme sistemi",
  productA35Feature3: "Kızılötesi otomatik yükseklik algılama",
  productA43Subtitle: "Amiral gemisi 8 renkli akıllı UV yazıcı",
  productA43Feature1: "A3 baskı formatı",
  productA43Feature2: "Çoklu baskı kafası yapılandırmaları",
  productA43Feature3: "Akıllı mürekkep besleme sistemi",
  productA46Subtitle: "Amiral gemisi 8 renkli akıllı UV yazıcı",
  productA46Feature1: "A2 baskı formatı",
  productA46Feature2: "Çoklu baskı kafası yapılandırmaları",
  productA46Feature3: "Akıllı mürekkep besleme sistemi",
  productA57Subtitle: "Amiral gemisi 8 renkli akıllı UV yazıcı",
  productA57Feature1: "A2+ baskı formatı",
  productA57Feature2: "Çoklu baskı kafası yapılandırmaları",
  productA57Feature3: "Akıllı mürekkep besleme sistemi",
  productA69Subtitle: "Amiral gemisi 8 renkli akıllı UV yazıcı",
  productA69Feature1: "A1 baskı formatı",
  productA69Feature2: "Çoklu baskı kafası yapılandırmaları",
  productA69Feature3: "Akıllı mürekkep besleme sistemi",
  productA1216Subtitle: "Amiral gemisi geniş format UV düz yatak yazıcı",
  productA1216Feature1: "1200×1600cm baskı formatı",
  productA1216Feature2: "Çoklu baskı kafası yapılandırmaları",
  productA1216Feature3: "Görsel konumlandırma sistemi",
  productA2513Subtitle: "Amiral gemisi geniş format UV düz yatak yazıcı",
  productA2513Feature1: "2500×1300cm baskı formatı",
  productA2513Feature2: "Çoklu baskı kafası yapılandırmaları",
  productA2513Feature3: "Görsel konumlandırma sistemi",
  productCylinderElfSubtitle: "360° yüksek hızlı silindirik yazıcı",
  productCylinderElfFeature1: "360° baskı",
  productCylinderElfFeature2: "Bardak ve şişe özelleştirme",
  productCylinderElfFeature3: "Hızlı aparat değişimi",
  productCupPlusSubtitle: "Çok boyutlu bardak ve şişe baskı çözümü",
  productCupPlusFeature1: "Çok boyutlu aparatlar",
  productCupPlusFeature2: "Yüksek üretim verimliliği",
  productCupPlusFeature3: "İstikrarlı çıktı",
  productCrystal60Subtitle: "Kristal etiket baskı ve folyo hepsi bir arada sistem",
  productCrystal60Feature1: "60cm genişlik",
  productCrystal60Feature2: "Baskı ve folyo entegrasyonu",
  productCrystal60Feature3: "Verimli sarma sistemi",
  productCrystalC60UltraFeature1: "60 cm genişlik",
  productCrystalC60UltraFeature2: "Altın/gümüş/3D silikon etiket seçenekleri",
  productCrystalC60UltraFeature3: "Seri üretim",
  productCrystal30Subtitle: "Kompakt yüksek hassasiyetli kristal etiket yazıcı",
  productCrystal30Feature1: "Kompakt hassas baskı",
  productCrystal30Feature2: "Kolay kullanım",
  productCrystal30Feature3: "Kişiselleştirilmiş özelleştirme",
  productDtf60Subtitle: "Beyaz mürekkepli DTF transfer yazıcı",
  productDtf60Feature1: "Beyaz mürekkepli DTF transfer",
  productDtf60Feature2: "Zengin renk katmanları",
  productDtf60Feature3: "Giyim aksesuarları",
  productDtfF20Subtitle: "Sektörün en küçük masaüstü beyaz mürekkepli DTF yazıcısı",
  productDtfF20Feature1: "A4 boyut",
  productDtfF20Feature2: "Küçük seri özelleştirme",
  productDtfF20Feature3: "Akıllı mürekkep sistemi",
  productDtfF30Subtitle: "Masaüstü beyaz mürekkepli DTF yazıcı",
  productDtfF30Feature1: "A3 boyut",
  productDtfF30Feature2: "Tek kafa manuel/otomatik seçenek",
  productDtfF30Feature3: "Akıllı mürekkep sistemi",
  productDtfF30ProSubtitle: "Beyaz mürekkepli DTF yazıcı",
  productDtfF30ProFeature1: "A3 boyut",
  productDtfF30ProFeature2: "Çift kafa otomatik film sarma",
  productDtfF30ProFeature3: "Akıllı mürekkep sistemi",
  productDtfF33Subtitle: "Beyaz mürekkepli DTF yazıcı",
  productDtfF33Feature1: "A3 boyut",
  productDtfF33Feature2: "Tek kafa manuel/otomatik seçenek",
  productDtfF33Feature3: "Akıllı mürekkep sistemi",
  productDtfF70ProSubtitle: "70 cm geniş format beyaz mürekkepli DTF yazıcı",
  productDtfF70ProFeature1: "A2 boyut",
  productDtfF70ProFeature2: "2�? kafa seçeneği",
  productDtfF70ProFeature3: "Otomatik besleme ve çıkış sistemi",
  productDtfF70ProFeature4: "Akıllı baskıya devam modu",
  productDtf30Subtitle: "Kompakt beyaz mürekkepli DTF yazıcı",
  productDtf30Feature1: "Küçük seri özelleştirme",
  productDtf30Feature2: "Doğru renk üretimi",
  productDtf30Feature3: "Kullanımı kolay",
  productDtgPrintSubtitle: "Dijital doğrudan tekstil yazıcı",
  productDtgPrintFeature1: "Çok malzemeli doğrudan baskı",
  productDtgPrintFeature2: "Yüksek verim",
  productDtgPrintFeature3: "Kararlı ve dayanıklı",
  productDtg3250DSubtitle: "Sektördeki tek DTF ve DTG 2'si 1 arada model",
  productDtg3250DFeature1: "A3+ format",
  productDtg3250DFeature2: "DTF ve DTG çift proses baskı",
  productDtg3250DFeature3: "Akıllı mürekkep sistemi",
  productDtg3646TSubtitle: "Çift istasyonlu DTG yazıcı",
  productDtg3646TFeature1: "Sürekli üretim modu",
  productDtg3646TFeature2: "%100 verimlilik artışı",
  productDtg3646TFeature3: "Akıllı mürekkep sistemi",
  productDtgMaxSubtitle: "Endüstriyel dijital DTG yazıcı",
  productDtgMaxFeature1: "Endüstriyel kapasite",
  productDtgMaxFeature2: "Kararlı ve dayanıklı",
  productDtgMaxFeature3: "Sürekli çalışma",
  app01Title: "Telefon kılıfları",
  app02Title: "Golf topları",
  app03Title: "Taş plaketler",
  app04Title: "Tükenmez kalemler",
  app05Title: "Gözlük kutuları",
  app06Title: "Ahşap baskılar",
  app07Title: "İçecek kutuları",
  app08Title: "Klavyeler",
  app09Title: "Termoslar",
  app10Title: "Bagaj",
  app11Title: "Akrilik ürünler",
  app12Title: "Defterler",
  app13Title: "Rozetler",
  app14Title: "Deri kartlıklar",
  app15Title: "Kimlik plaketleri",
  app16Title: "Cam sanatı",
  appDtgCase01: "Tişörtler",
  appDtgCase02: "Kapüşonlular",
  regionCn: "Çin",
  regionUs: "Amerika Birleşik Devletleri",
  regionGb: "Birleşik Krallık",
  regionDe: "Almanya",
  regionAe: "BAE",
  regionIn: "Hindistan",
  regionJp: "Japonya",
  regionVn: "Vietnam",
  regionBr: "Brezilya",
  regionAu: "Avustralya",

  // synced from en
    uiClose: "Close",
    carouselPrev: "Previous product",
    carouselNext: "Next product",
    heroSlidePrev: "Previous slide",
    heroSlideNext: "Next slide",
    heroSlideDot: "Go to slide {n}",
    customerStoriesTrustedTitle: "Trusted Worldwide",
    customerStoriesBadge: "{count} international customer photos showcased",
    customerStoryCountryUsaNewYork: "New York, USA",
    customerStoryCountryGermany: "Germany",
    customerStoryCountryThailand: "Thailand",
    customerStoryCountrySpain: "Spain",
    customerStoryCountryBrazil: "Brazil",
    customerStoryCountryAustralia: "Australia",
    customerStoryCountrySaudiArabia: "Saudi Arabia",
    customerStoryCountrySingapore: "Singapore",
    customerStoryCountryKorea: "South Korea",
    customerStoryCountryIsrael: "Israel",
    customerStoryCountryKazakhstan: "Kazakhstan",
    customerStoryCountryMexico: "Mexico",
    customerStoryCountryArgentina: "Argentina",
    customerStoryCountryPhilippines: "Philippines",
    customerStoryCountryIndonesia: "Indonesia",
    customerStoryCountryNetherlands: "Netherlands",
    customerStoryCountrySweden: "Sweden",
    customerStoryCountrySouthAfrica: "South Africa",
    customerStoryCountryMalaysia: "Malaysia",
    customerStoryCountryTaiwan: "Taiwan",
    customerStoryCountryUsa: "United States",
    customerStoryCaption01: "USA�?090 UV Printer",
    customerStoryCaption02: "Germany｜F33 DTF Printer",
    customerStoryCaption03: "Thailand�?250 UV Printer",
    customerStoryCaption04: "Spain�?250 UV Printer",
    customerStoryCaption05: "Brazil�?030 UV Printer",
    customerStoryCaption06: "Australia｜F33 DTF Printer",
    customerStoryCaption07: "Saudi Arabia�?030 UV Printer",
    customerStoryCaption08: "Singapore｜F33 DTF Printer",
    customerStoryCaption09: "South Korea｜F33 DTF Printer",
    customerStoryCaption10: "Israel｜UVC33 DTF Printer",
    customerStoryCaption11: "Kazakhstan�?030 UV Printer",
    customerStoryCaption12: "Mexico�?060 UV Printer",
    customerStoryCaption13: "Argentina�?060 UV Printer",
    customerStoryCaption14: "Philippines�?090 UV Printer",
    customerStoryCaption15: "Indonesia�?030 UV Printer",
    customerStoryCaption16: "Netherlands�?030 UV Printer",
    customerStoryCaption17: "Sweden�?060 UV Printer",
    customerStoryCaption18: "Germany�?030 UV Printer",
    customerStoryCaption19: "South Africa�?030 UV Printer",
    customerStoryCaption20: "Malaysia｜F33 DTF Printer",
    customerStoryCaption21: "Taiwan｜UVC33 DTF Printer",
    customerStoryCaption22: "USA｜F70Pro DTF Printer",
    customerStoryCaption23: "USA�?513 UV Printer",
    customerStoryCaption24: "USA�?090 UV Printer",
    customerStoryCaption25: "USA�?030 UV Printer",
    customerStoryCaption26: "USA�?250 UV Printer",
    customerStoryCaption27: "South Korea�?060 UV Printer",
    customerStoryCaption28: "Netherlands�?060 UV Printer",
    catUvNav: "UV Flatbed",
    catCylinderNav: "Cylindrical",
    catCrystalNav: "Crystal Label",
    catDtfNav: "DTF",
    catDtgNav: "DTG",
    productA3220Subtitle: "Ultra Wide-Format Industrial UV Flatbed Solution",
    productA3220Feature1: "320×200cm Print Format",
    productA3220Feature2: "Visual Positioning System",
    productA3220Feature3: "Continuous Batch Production",
    productCrystal60UltraSubtitle: "Flagship Crystal Label Printing Solution",
    cityShanghai: "Shanghai",
    cityShenzhen: "Shenzhen",
    cityDetroit: "Detroit",
    cityManchester: "Manchester",
    cityStuttgart: "Stuttgart",
    cityDubai: "Dubai",
    cityPune: "Pune",
    cityOsaka: "Osaka",
    cityHoChiMinh: "Ho Chi Minh City",
    citySaoPaulo: "São Paulo",
    cityMelbourne: "Melbourne",
};
